


export const UPCOMING_FEATURE_LIST = [
  /* {
    key: 'calendar.recurringEvents',
    name: 'Calendar Recurring Events',
    details: {
      heading: 'New feature: Book recurring appointments',
      body: `Recurring event details`,
    },
    liveAt: '2022-11-20T00:00:00.000Z',
  },  */
  {
    key: 'conversations.newLayout',
    name: 'Conversations',
    details: {
      heading: 'New features in the conversations page',
      body: `What is new with this update?<br><br>
            <b>1.</b> Ability to perform bulk actions<br>
              <ul style="list-style-type:disc; margin-left: 25px;">
                <li>Mark conversations as Read</li>
                <li>Mark conversations as Unread</li>
                <li>Mark conversations as Starred</li>
                <li>Mark conversations as Unstarred</li>
                <li>Delete conversations</li>
              </ul>
            <br>
            <b>2.</b> Ability to filter conversations (quick filters)<br>
              <ul style="list-style-type:disc;  margin-left: 25px;">
                <li>By conversation type</li>
                <li>By assignee</li>
                <li>By last message channel</li>
              </ul>
            <br>
            <b>3.</b> Ability to sort conversations<br>
              <ul style="list-style-type:disc;  margin-left: 25px;">
                <li>Latest to oldest</li>
                <li>Oldest to latest</li>
              </ul>
            <br>
            <b>4.</b> Introduction of “Starred” functionality: Ability to mark conversations as “Starred” that are important in nature, require future attention or any other reasons apply to you. Use filters to get to the list of starred ones seamlessly.<br>
            <br>
            `,
    },
    liveAt: '2022-12-12T00:00:00.000Z',
    toggleHidden: false,
  },
  {
    key: 'conversations.scheduleMessage',
    name: 'Conversations',
    details: {
      heading: 'Schedule Message Feature (Conversations Page)',
      body: `What’s New
            <br><br>
            Introducing the ability to schedule an email & SMS on the conversation page. Schedule messages (Email & SMS) for different timezones,
            view them on your conversation thread and cancel the schedule if needed. A seamless & effective way to send your messages later.`,
    },
    liveAt: '2022-12-12T00:00:00.000Z',
    toggleHidden: false,
  },
  {
    key: 'calendar.newSettingsPage',
    name: 'Calendar Settings Consolidation',
    details: {
      heading: 'New features + Updated UI',
      body: `<br>This update includes,<br>
          <b>1.</b> Enhanced UI: Completely redesigned interface for Configuring your Calendars<br>
          <b>2.</b> Rearrange Calendars within Group: Drag and drop interface to rearrange your calendars<br>
          <b>3.</b> Calendar setup consolidation: Configure and access all your calendar settings in one place<br>
          <b>4.</b> Search and Filter: Improved Ul to filter and search your calendars<br>
          <b>5.</b> All calendars can now be disabled/enabled, duplicated<br>
          <b>6.</b> Move to Group (in progress)<br>
          <b>7.</b> Permanent URL in Embed Code (in progress)<br>
          <b>8.</b> Improvements to Custom URL: now accepts multiple params - "/ghl/marketing/15mins-team-call" (in progress)<br>
      `
    },
    liveAt: '2022-12-30T00:00:00.000Z',
  },
  {
    key: 'notifications.preferences',
    name: 'Notification preferences & enhancements',
    details: {
      heading: '',
      body: `<br>
      <b>What’s New;</b><br>
      - Ability to set notification preferences for web & mobile.<br>
      - Ability to enable & disable notifications based on user preferences.<br>
      - Introduction of two new types of notifications: Assigned to notifications for conversations & tasks.<br>
      - Ability to distinguish between system & custom notifications in the notification screen.<br>
      - Ability to clear notifications.<br>
      - Notification screen design enhancements for a seamless user experience.<br>`,
    },
    liveAt: '2022-11-01T00:00:00.000Z',
    toggleHidden: false,
  },
  {
    key: 'integrations.tiktok',
    name: 'TikTok',
    details: {
      heading: 'Integrate with TikTok to generate new leads',
      body: `<br>
        <b>1.</b>Authenticate account with TikTok business account. <br>
        <b>2.</b>Select desired Advertiser account to get instant pages.<br>
        <b>2.</b>Map instant page fields with GHL contacts fields.<br>
        <b>3.</b>Subscribe to specific page to generate new leads.<br>
        <b>4.</b>Once all the steps are completed, New leads will start appearing on smart list if users start enrolling.<br>
        <br>
        We would grateful if you could share your valuable feedbacks and report any issues.`,
    },
    liveAt: '2022-11-01T00:00:00.000Z',
    toggleHidden: false,
  },
  {
    key: 'membership.membershipPWA',
    name: 'Membership',
    details: {
      heading: 'Custom White Label Learner App',
      body: `Improved Learner Experience With Custom Whitelable Progressive Web APP. <br>
             Set up you branded PWA under app settings which can be installed by your learners from Chrome in desktop and Safari in IOS and Chrome in Android.<br>
             We have improved the learners experience in the preview side which also brings in a-lot of speed improvements if PWA is installed.`
    },
    liveAt: '2022-10-24T00:00:00.000Z'
  },
  {
    key: "membership.assessments",
    name: "Membership - Assessments",
    details: {
      heading: "Assessments",
      body: `Assessments are live in membership.<br><br>
             Create Single Choice / Multiple Choice Quiz to access the progress of your learners.
             View and track all the submissions under analytics`
    },
    liveAt: '2022-10-24T00:00:00.000Z'
  },
  {
    key: 'marketing.affiliateManager',
    name: 'Affiliate Manager',
    details: {
      heading: 'Expand your sales network and increase your revenue with Affiliate Manager',
      body: `<br><h5>Pre-requisite for making an Affiliate Manager\'s Campaign live</h5><b>1.</b> Enable Stripe Connect on your locations (Settings -> Integrations -> Strip Connect)<br>
          <b>2.</b> Add/Upload Affiliates on Affiliate Manager<br>
          <b>3.</b> Create your campaign with<br>
          <ul class="ml-4" style="list-style: circle;">
            <li>Funnel/website selection</li>
            <li>Products that you want the commission split on</li>
            <li>List of affiliates</li>
            <li>Commission percentage</li>
            <li>Payout frequency</li>
            <li>Cookie life.</li>
          </ul><br>
          <h5>Affiliate Manager Flow</h5>
          <b>1.</b> Once an affiliate campaign is created and made live, all the enrolled affiliates will receive their unique affiliate link which they can share with their network.<br>
          <b>2.</b> As soon as a customer signs up through an affiliate link, the payout and commission gets recorded and is published on the 'Payout - Pending' tab on the 1st of the following month.<br>
          <b>3.</b> The affiliate owner can see the list of all the generated payouts and chose to approve or deny them for a payout.<br>
          <b>4.</b> Once they are approved for a payout, the affiliate owner needs to take an export and upload it on their payment gateway to make the payment.<br>
          <b>5.</b> Once the payment has been made, the affiliate owner needs to update the status in Affiliate Manager so that correct reporting gets reflected for that affiliate and the overall campaign.<br><br>
          We'll be release more updates soon, till then we are excited to hearing your feedback so that we can improve Affiliate Manager for you.
      `
    },
    liveAt: '2022-10-24T00:00:00.000Z',
  },
  {
    key: "customFields.version2",
    name: "Contacts new feature - Custom fields folder",
    details: {
      heading: "Custom Fields New UI",
      body: `<br> What's new. <br>
            1. Ability to create custom folders & map fields in it <br>
            2. Ability to move fields (standard or custom) between different folders <br>
            3. The new view of the contact details page with folders <br>
            4. Ability to restructure contact fields seamlessly <br>`
    },
    liveAt: '2022-11-01T00:00:00.000Z'
  },
  {
    key: "businesses.version1",
    name: "Company",
    details: {
      heading: "Company Object Feature",
      body: `<br>
            1. Introduction of a new entity called companies in your account. <br>
            2. Ability to create companies & add their details seamlessly. <br>
            3. Ability to map contacts with companies and view details under the contact page. <br>
            4. Ability to add multiple contacts to a company.<br>
            5. Ability to view the group of contacts mapped to a company in a singular view.<br>
            `
    },
    liveAt: '2022-11-01T00:00:00.000Z'
  },
  {
    key: 'reporting.adReporting',
    name: 'Ad Reporting',
    details: {
      heading: 'New features and enhancements on Google Ad and Facebook Ad Reporting',
      body: `<br>This update includes,<br>
          <b>1.</b> <strong>Enhanced UI:</strong> Completely redesigned interface for Google and Facebook Ads reporting. <br>
          <b>2.</b> <strong>Visual Charts:</strong> Impressions, Clicks and Conversions for selected date range are presented with charts. <br>
          <b>3.</b> <strong>Markup Fee / Management Fee:</strong> You can add monthly management fee to your client’s ad spending. These fee will be added to all cost related metrics and will be displayed in the ad reporting. <br>
          <b>4.</b> <strong>Search and Export data:</strong> The campaign table now includes search functionality as well as allow you to export the data of all campaign or specific campaign.<br>
          <b>5.</b> <strong>Campaign View:</strong> View all the campaign performance metrics by clicking the name and get the details about Ads and Keywords performance (for Google ads) or Adset performance (for Facebook ads).<br>
          <b>6.</b> <strong>Campaign Objective:</strong> User can set the goal for a campaign from dropdown or add their own by selecting "Other". <br>
      `
    },
    liveAt: '2022-09-10T00:00:00.000Z',
    toggleHidden: true,
  },
  {
    key: 'membership.libraryV2',
    name: 'Membership',
    details: {
      heading: 'In App Upsell',
      body: `<div class="font-semibold text-lg text-gray-700">What is an In App Upsell?</div>
              An In App Upsell is used as a way to sell another Offer or Product from the My Library page after the initial offer has been purchased.
              Course takers will see locked products or course bundles in the My Library Page where they can choose to make an additional purchase.
              <div class="font-semibold text-lg text-gray-700">Note:</div>
              1. Multiple In-App Upsells can be added to a single offer <br/>
              2. We have updated your my library page to facilitate In-App Upsells.
              Any existing Advance CSS/JS applied to <span class="font-semibold text-gray-700">My Library</span> page might not work properly when this feature is enabled. Please ensure you have revisited the advance section by going to <span class="font-semibold text-gray-700">Settings > Site Details > Advance</span><br/>
              `,
    },
    liveAt: '2022-07-26T00:00:00.000Z',
    toggleHidden: true
  },
  {
    key: 'calendar.popover',
    name: 'Calendar Popover and Activity log',
    details: {
      heading: 'Improvements to the Booking flow',
      body: `<br> With this update, <br>
            1. View a quick summary of all Calendar Appointments as well as incoming events coming in from Google/Outlook <br>
            2. View detailed activity logs explaining all changes made to appointments every step along the way <br>
            3. View exact date and time of crucial third party (Google/Outlook) sync updates <br>`,
    },
    liveAt: '2022-06-20T00:00:00.000Z',
  },
  {
    key: 'smartList.filterUIV2',
    name: 'Contacts Page',
    details: {
      heading: 'Improvement in Filters',
      body: `With this update, <br>
                1. Better experience creating and managing Smartlists <br>
                2. All users will have the ability to differentiate between ‘And’ and ‘Or’ Filters (‘Or’ update will be made available in Q1 ’22) <br>
                3. All users will be able to view available filters organised by modules`,
    },
    liveAt: '2022-03-31T00:00:00.000Z',
  },
  {
    key: 'calendar.newApptModal2',
    name: 'Calendar Booking flow',
    details: {
      heading: 'Improvements to the Booking flow',
      body: `<br> With this update, <br>
            1. One modal, one experience while booking an appointment across different parts of the app <br>
            2. No more un-intentionally over-riding contact records while picking a contact for the appointment <br>
            3. Ability to know beforehand the local time of the person with whom you'd book the appointment (if it is different than the sub-account timezone) <br>
            4. Improved experience when you are "Blocking Off" slots <br>
            5. Being able to over-ride the default calendar time-slots with custom time <br>
            6. No more confusion while booking appointments among same name contacts <br>
            7. Alphabetically sorted Teams/Groups and their respective calendars for better accessibility <br>
            8. Pre-populate Appointment Title from the Calendar Settings <br>
            9. Book Appointments in any timezone of your choice <br>
            10. Book Unconfirmed Appointments on any calendar <br>
            11. Ability to start adding names and descriptions to the blocked off slots <br>
            12. Transparency on what happens when you block off slots <br>`,
    },
    liveAt: '2022-03-28T00:00:00.000Z',
  },
  {
    key: 'conversations.messageDetails',
    name: 'Conversations',
    details: {
      heading: 'Conversation Message Details',
      body: `New changes to Conversations page. You will now be able to see the origin or each individual message inside the conversation view. This will help you find out all the relevant details for each individual message sent or recieved in the system.
            <br><br><span style="color: rgba(55, 65, 81); font-weight: bold;">Note</span>: All the past messages may not display accurate information.`,
    },
    liveAt: '2022-07-25T00:00:00.000Z',
  },
  {
    key: 'funnels.preview',
    name: 'Funnels & Websites',
    details: {
      heading: 'Funnels/Websites Preview',
      body: `With the new upcoming updates, there's a chance that your funnels do not work as it did before. This can include but not limited failure due to custom custom CSS, JS scripts, tracking code (header and footer), SEO and custom HTML elements. Just to be sure, we recommend that you preview your funnels using the options below to ensure that your funnels work as before even before the release goes live.`,
    },
    toggleHidden: true,
    liveAt: '2022-07-23T00:00:00.000Z',
  },
  {
    key: 'forms.preview',
    name: 'Forms',
    details: {
      heading: 'Forms Preview',
      body: `With the new upcoming updates, there's a chance that your forms do not work as it did before. This can include but not limited failure due to custom custom CSS, JS scripts, tracking code / Facebook pixel, sticky contacts, custom values and custom HTML elements. Just to be sure, we recommend that you preview your forms using the options below to ensure that your forms work as before even before the release goes live.`,
    },
    toggleHidden: true,
    liveAt: '2022-07-23T00:00:00.000Z',
  },
  {
    key: 'surveys.preview',
    name: 'Surveys',
    details: {
      heading: 'Surveys Preview',
      body: `With the new upcoming updates, there's a chance that your surveys do not work as it did before. This can include but not limited failure due to custom custom CSS, JS scripts, tracking code / Facebook pixel, sticky contacts, custom values and custom HTML elements. Just to be sure, we recommend that you preview your surveys using the options below to ensure that your surveys work as before even before the release goes live.`,
    },
    toggleHidden: true,
    liveAt: '2022-07-23T00:00:00.000Z',
  },
  {
    key: 'calendars.preview',
    name: 'Calendars',
    details: {
      heading: 'Calendars Preview',
      body: `With the new upcoming updates, there's a chance that your calendars do not work as it did before. This can include but not limited failure due to custom custom CSS, JS scripts, tracking code / Facebook pixel, sticky contacts, custom values and custom HTML elements. Just to be sure, we recommend that you preview your calendars using the options below to ensure that your calendars work as before even before the release goes live.`,
    },
    toggleHidden: true,
    liveAt: '2022-07-23T00:00:00.000Z',
  },
  {
    key: 'email_builder.campaign',
    name: 'Email',
    details: {
      heading: 'Improvements in Email Template and Email Campaign flow',
      body: `We have made changes to user experience of Email with differentiation of Email Template and Email Campaigns. Email template is where add the brand layout/design of email and Email Campaign is where you add message and delivery option for mailing the customers. Here's the changes implemented.<br><br>
          <b>Email Template</b><br>
          <b>1.</b> User can create template via Template Library, Create Template by reusing Campaigns and Blank Template (Option between Design editor (Drag and drop experience) and Code editor (HTML experience). <br>
          <b>2.</b> User can manage and organise them with Folder, Filter and Search capabilities. <br> <br>
          <b>Email Campaign </b><br>
          <b>1.</b> User can choose the template which they would like or create from blank campaign (Option between Design editor (Drag and drop experience) and Code editor (HTML experience). <br>
          <b>2.</b> User can reschedule the campaign before one hour (60mins) of execution date/time. <br>
          <b>3.</b> User can update the ongoing Email Campaign before next execution date/time. [Note -We will try to change the copy in server but we are not 100% sure if the users will get updated email content] <br>
          <b>4.</b> User will be able to see enhanced statistics which were available in bulk actions along with option to switch between percentage or numbers. <br> <br>
          We would grateful if you could share your valuable feedbacks and report any issues.`,
    },
    liveAt: '2022-06-23T00:00:00.000Z',
    toggleHidden: true,
  },
  {
    key: 'blogging.platform',
    name: 'Blogging',
    details: {
      heading: 'Create, Optimise and distribute your content marketing with Blog',
      body: `<br>
        <b>1.</b>Create the Blog Post with SEO details with title of blog post, description and Feature image. <br>
        <b>2.</b>Create and contribute to Blog Post with strong new editor with images, videos, quotes, emoji. <br>
        <b>3.</b>User should be able to publish or save in draft with URL Slug, category, author and tags<br>
        <b>4.</b>User can update the Blog post if it is published and the content requires change. <br>
        <b>5.</b>User can add or update the details of Category and Author details. <br>
        <b>6.</b>Once the blog posts are ready, create funnel steps or website page with the element of Blog Post Content. <br>
        <b>7.</b>User can choose the option between Standard or Compact view of Blog Post Content with dummy blog posts. <br>
        <b>8.</b>Once the funnel step or website page are published, user will be able to see the blog post contents. <br>
        <br>
        We would grateful if you could share your valuable feedbacks and report any issues.`,
    },
    liveAt: '2022-08-30T00:00:00.000Z',
    toggleHidden: true,
  }
]



export const isFeatureLive = (): boolean => {
  // removed this logic because we are handling this in backend.
   return false
}
